import cn from 'clsx';
import { Sku } from '@v2/shared/lib/types';
import useProductPriceLogic from '@v2/shared/lib/useProductPriceLogic';
import Price from '@v2/shared/components/Price';

type SalePriceProps = {
  sku: Sku;
  className?: string;
};

export default function SalePrice({ sku, className }: SalePriceProps) {
  const { onSale, showSavings } = useProductPriceLogic(sku);

  return (
    <span className={className}>
      <Price className={cn('mr-2', { 'text-red-600': showSavings })} value={sku.sale_price || sku.price} />
      {onSale && (
        <Price className={cn('relative ml-1')} value={sku.price}>
          <Crossout />
        </Price>
      )}
    </span>
  );
}

function Crossout() {
  return (
    <em
      className={cn(
        'absolute block w-[110%] -left-[5%] bottom-[50%]',
        'transform -rotate-[8deg] rotate',
        'border-2 border-red-600 bg-red-600'
      )}
    />
  );
}
